import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f7849c1c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "line-chart-warp"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart"
}, null, -1));

const _hoisted_3 = [_hoisted_2];
import * as echarts from 'echarts';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/_defineComponent({
  __name: 'LineChart',

  setup(__props) {
    const {
      t
    } = useI18n();
    let myChart = null; // onMounted(() => {
    //     initChart();
    // });

    const languageTotalList = inject('languageTotalList');

    const initChart = () => {
      setTimeout(() => {
        if (!languageTotalList.value || !languageTotalList.value.length) {
          if (myChart) myChart.dispose();
          document.getElementById('myChart')?.removeAttribute('_echarts_instance_');
          myChart = echarts.init(document.getElementById('myChart'));
          myChart.showLoading({
            text: t('加载中...'),
            color: '#4ea5ff',
            textColor: '#000',
            maskColor: 'rgba(255, 255, 255, 0.2)',
            zlevel: 0,
            lineWidth: 2,
            spinnerRadius: 12,
            fontSize: 14
          });
          setTimeout(() => {
            // setOption前隐藏loading事件 
            myChart.hideLoading(); // 绘制图表

            myChart.setOption({
              title: {
                text: t('暂无数据'),
                x: 'center',
                y: 'center',
                textStyle: {
                  color: '#65ABE7',
                  fontWeight: 'normal',
                  fontSize: 25
                }
              }
            }, true);
          }, 1000); // myChart.setOption(option.value);

          window.addEventListener('resize', () => {
            myChart.resize();
          }, {
            passive: false
          });
        } else {
          let seriesData = [];
          languageTotalList.value.forEach(item => {
            let data = [item.onlineCount || 0, item.newAddCount || 0, item.offlineCount || 0, item.deleteCount || 0, item.subtitleCount || 0];
            seriesData.push({
              name: item.language + ' ' + t('合计'),
              type: 'bar',
              barGap: '10%',
              barWidth: 26,
              emphasis: {
                focus: 'series'
              },
              data,
              itemStyle: {
                normal: {// color: '#aa4643'
                }
              }
            });
          });
          let option = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            legend: {
              type: 'scroll',
              // orient: 'vertical',
              // right: 0,
              // top: 130,
              bottom: 0,
              // padding: [0, 0, 0, 10]
              // x: 'right',      // 可设定图例在左、右、居中
              // y: 'center',     // 可设定图例在上、下、居中
              icon: 'circle',
              itemWidth: 12,
              itemHeight: 12,
              textStyle: {
                fontSize: 12,
                height: 12,
                lineHeight: 12,
                padding: [0, 0, -3, 0],
                rich: {
                  a: {
                    verticalAlign: 'middle'
                  }
                }
              }
            },
            grid: {
              top: '10%',
              left: '3%',
              right: '6%',
              bottom: '16%',
              containLabel: true
            },
            xAxis: [{
              type: 'category',
              data: [t('上线'), t('新增节目'), t('下线'), t('删除节目'), t('字幕')] // axisLabel: {
              //     interval: 0,
              //     rotate: 40,
              // },

            }],
            yAxis: [{
              type: 'value',
              name: t('数量'),
              nameTextStyle: {
                color: '#36373A',
                fontWeight: 'bold',
                padding: [0, 30, 10, 0]
              }
            }],
            series: seriesData,
            dataZoom: [{
              type: 'slider',
              show: true,
              start: 0,
              height: 12,
              end: 100,
              handleSize: 10,
              bottom: '9%'
            }, {
              type: 'inside',
              start: 0,
              right: 0
            }, {
              type: 'slider',
              show: true,
              yAxisIndex: 0,
              filterMode: 'empty',
              width: 12,
              handleSize: 8,
              right: '3%',
              showDataShadow: false
            }]
          }; // console.log('seriesData', seriesData);

          if (myChart) myChart.dispose();
          document.getElementById('myChart')?.removeAttribute('_echarts_instance_');
          myChart = echarts.init(document.getElementById('myChart'));
          myChart.showLoading({
            text: t('加载中...'),
            color: '#4ea5ff',
            textColor: '#000',
            maskColor: 'rgba(255, 255, 255, 0.2)',
            zlevel: 0,
            lineWidth: 2,
            spinnerRadius: 12,
            fontSize: 14
          });
          setTimeout(() => {
            // setOption前隐藏loading事件 
            myChart.hideLoading();
            myChart.setOption(option);
          }, 1000); // myChart.setOption(option.value);

          window.addEventListener('resize', () => {
            myChart.resize();
          }, {
            passive: false
          });
        }
      }, 100);
    };

    watch(() => languageTotalList.value, val => {
      // console.log('languageTotalList', languageTotalList);
      initChart();
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
    };
  }

});